import { useEffect, useState } from "react";
import styles from "./CustomRadioInput.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const CustomRadioInput = ({
  options = {},
  groupKey,
  label,
  required,
  onSelect,
  error,
  value,
  showErrorMessage,
  ...rest
}: any) => {
  const [selected, setSelected] = useState(value);
  useEffect(() => setSelected(value), [value]);

  const handleSelect = (option: any) => {
    onSelect(option);
    setSelected(option);
  };

  return (
    <div className={styles.radioGroupContainer}>
      {label && (
        <div className={styles.radioGroupHeader}>
          {label} {required && <span className={styles.required}>*</span>}
        </div>
      )}
      <div className={styles.radioInputSection} style={rest.style ? { ...rest.style } : {}}>
        {Object.keys(options).map((option, index) => (
          <div
            role="none"
            key={`${option}_${index}`}
            className={styles.radioInput}
            onClick={() => handleSelect(option)}
          >
            <input
              type="radio"
              value={option}
              checked={selected === option}
              name={groupKey}
              data-testid={value}
            />
            <div className={styles.radioCheckmark} />
            <div>{options[option]}</div>
          </div>
        ))}
      </div>
      {showErrorMessage && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default wrapperHOC(CustomRadioInput, {
  componentName: "CustomRadioInput-BookForm",
  showForChina: true,
});
